import React, { useState, useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import TextField from '@material-ui/core/TextField';
import MuiAlert from '@material-ui/lab/Alert';
import { useNavigate } from 'react-router-dom';
import { createManualNotifications } from '../graphql/mutations';
import { listGuidances } from '../graphql/queries';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Button,
  Checkbox,
  Radio,
  FormControl,
  Select,
  MenuItem,
  Container,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '200vh',
  },
  form: {
    width: '80%', // Adjust this value to control the form width
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formControl: {
    marginBottom: theme.spacing(2),
    width: '100%', // Make the form fields wider
  },
}));

const AddNotificationForm = () => {
  const navigate = useNavigate();
  const classes = useStyles();

  // State variables to store form input values
  const [title, setTitle] = useState('');
  const [shortDescription, setShortDescription] = useState('');
  const [guidanceItems, setGuidanceItems] = useState([]);
  const [selectedGuidance, setSelectedGuidance] = useState('');

  // State variable to manage success state and error state
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState(null);

  // Fetch guidance items from GraphQL query on component mount
  useEffect(() => {
    const fetchGuidanceItems = async () => {
      try {
        const { data } = await API.graphql(graphqlOperation(listGuidances));
        const guidanceItems = data.listGuidances.items;
        setGuidanceItems(guidanceItems);
      } catch (error) {
        console.error('Error fetching guidance items:', error);
      }
    };

    fetchGuidanceItems();
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare the input object for the GraphQL mutation
    const input = {
      title,
      shortText: shortDescription,
      manualNotificationsGuidanceId: selectedGuidance,
    };

    try {
      // Perform the GraphQL mutation to create the notification
      await API.graphql(graphqlOperation(createManualNotifications, { input }));

      // Set the success state to true to show the success notification
      setShowSuccess(true);

      // Clear any previous errors
      setError(null);

      setTitle('');
      setShortDescription('');
      setSelectedGuidance('');

      // Redirect to a success page or any other desired action after successful submission
      // navigate('/success'); // Uncomment this line if you want to redirect to a success page

    } catch (error) {
      console.error('Error creating notification:', error);

      // Set the error state to the error message to show the error notification
      setError('Error creating notification.');

      // Set the success state to false to hide any previous success notification
      setShowSuccess(false);
    }
  };

  return (
    <Container className={classes.container}>
      <form onSubmit={handleSubmit} className={classes.form}>
        <TextField
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          className={classes.formControl}
        />
        <TextField
          label="Short Description"
          value={shortDescription}
          onChange={(e) => setShortDescription(e.target.value)}
          required
          className={classes.formControl}
        />
        <FormControl className={classes.formControl}>
          <Select
            value={selectedGuidance}
            onChange={(e) => setSelectedGuidance(e.target.value)}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select a Guidance
            </MenuItem>
            {guidanceItems.map((guidance) => (
              <MenuItem key={guidance.id} value={guidance.id}>
                {guidance.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button type="submit" variant="contained" color="primary">
          Submit
        </Button>
        {/* Show error and success notifications */}
        {error && <MuiAlert severity="error">{error}</MuiAlert>}
        {showSuccess && (
          <MuiAlert severity="success">Notification created successfully!</MuiAlert>
        )}
      </form>
    </Container>
  );
};

export default AddNotificationForm;
